import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './_guards';

import { HomeComponent } from './login/home.component';
import { LoginComponent } from './login/login.component';
import { OtpComponent } from './otp/otp.component';
import { VerifyComponent } from './verify/verify.component';
import { UploadpicComponent } from './verify/upload-pic.component';
import { LaunchpageComponent } from './verify/launch-page.component';
import { TestComponent } from './test/test-page.component';
import { VivaComponent } from './test/viva-page.component';
import { TestNoStreamComponent } from './test/test-page-nostream.component';
import { UploadidpicComponent } from './verify/upload-idpic.component';
import { PracticalLaunchpageComponent } from './verify/practical-launch-page.component';
import { PracticalComponent } from './test/practical-page.component';
import { ThanksComponent } from './test/thanks-page.component';
import { DescriptiveExamComponent } from './descriptive-exam/descriptive-exam.component';
import { FeedbackstartComponent } from './verify/feedback-start.component';
import { FeedbackComponent } from './verify/feedback.component';
import { UserLoginComponent } from './login/user-login.component';
import { LoginotpComponent } from './login/loginotp.component';
import { UserSignupComponent } from './login/user-signup.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { VerifyOtpComponent } from './forget-password/verifyotp.component';
import { CheckOtpComponent } from './login/checkotp.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AadhaarOtpComponent } from './verify/aadhaar-otp.component';
import { ForgetUsernameComponent } from './forget-username/forget-username.component';
import { SectorComponent } from './dashboard/sector.component';
import { QualificationComponent } from './dashboard/qualification.component';
import { InstructionComponent } from './dashboard/instruction.component';
import { EditProfileComponent } from './my-profile/edit-profile.component';
import { ResultsComponent } from './dashboard/results.component';
import { BuyexamComponent } from './dashboard/buyexam.component';
import { TransactionComponent } from './dashboard/transaction.component';
import { PsychometricComponent } from './psychometric/psychometric.component';
import { PsychometricWlsComponent } from './psychometric/psychometric-wls.component';
import { TypingSimulationComponent } from './typing/typing-simulation.component';
import { AdaptiveLaunchpageComponent } from './adaptive/adaptive-launch-page.component';
import { AdaptiveComponent } from './adaptive/adaptive.component';
import { AdaptiveWlsComponent } from './adaptive/adaptive-wls.component';
import { Test3Component } from './theory3/test-page.component';
import { Test3NoStreamComponent } from './theory3/test-page-nostream.component';

const routes: Routes = [
	{ path: '', redirectTo: '/home', pathMatch: 'full' },
	{ path: 'home', component: HomeComponent },
	{ path: 'login', component: LoginComponent },
	{ path: 'login/:step', component: LoginComponent },
	{ path: 'userlogin', component: UserLoginComponent },	
	{ path: 'loginotp', component: LoginotpComponent },	
	{ path: 'checkotp/:step/:step1',component:CheckOtpComponent},
	{ path: 'signup', component: UserSignupComponent },	
	
	{ path: 'otp/:step', component: OtpComponent, canActivate: [AuthGuard] },
	{ path: 'verify/:step', component: VerifyComponent, canActivate: [AuthGuard] },
	{ path: 'upload-pic/:step', component: UploadpicComponent, canActivate: [AuthGuard] },
	{ path: 'upload-idpic/:step', component: UploadidpicComponent, canActivate: [AuthGuard] },
	{ path: 'practical-welcome/:step', component: PracticalLaunchpageComponent, canActivate: [AuthGuard] },
	{ path: 'practical-start/:step', component: PracticalComponent, canActivate: [AuthGuard] },
	{ path: 'practical-end/:step', component: ThanksComponent, canActivate: [AuthGuard] },
	{ path: 'test-start/:step', component: LaunchpageComponent, canActivate: [AuthGuard] },
	{ path: 'theory-test/:step', component: TestComponent, canActivate: [AuthGuard] },
	{ path: 'theory-test-nols/:step', component: TestNoStreamComponent, canActivate: [AuthGuard] },
	{ path: 'viva-test/:step', component: VivaComponent, canActivate: [AuthGuard] },
	{ path: 'descriptive', component: DescriptiveExamComponent, canActivate: [AuthGuard] },
	{ path: 'start-feedback', component: FeedbackstartComponent, canActivate: [AuthGuard] },
	{ path: 'feedback/:step', component: FeedbackComponent, canActivate: [AuthGuard] },

	{path:'dashboard', component:DashboardComponent, canActivate: [AuthGuard] },
	{path:'buyexam/:step', component:BuyexamComponent, canActivate: [AuthGuard] },
	{path:'my-profile',component:MyProfileComponent, canActivate: [AuthGuard]},
	{path:'edit-profile',component:EditProfileComponent, canActivate: [AuthGuard]},
	{path:'results/:step1/:step2',component:ResultsComponent, canActivate: [AuthGuard]},
	{path:'sectors',component:SectorComponent, canActivate: [AuthGuard]},
	{path:'qpacks/:step',component:QualificationComponent, canActivate: [AuthGuard]},
	{path:'instruction/:step/:step1',component:InstructionComponent, canActivate: [AuthGuard]},
	{path:'forget-password',component:ForgetPasswordComponent},	
	{path:'verifyotp/:step',component:VerifyOtpComponent},
	{path:'reset-password/:step',component:ResetPasswordComponent},
	{path:'change-password',component:ChangePasswordComponent},
	{path:'aadhaarotp',component:AadhaarOtpComponent},	
	{path:'forget-username',component:ForgetUsernameComponent},		

	{path:'transactions',component:TransactionComponent, canActivate: [AuthGuard]},
	{path:'psychometric/:step',component:PsychometricComponent, canActivate: [AuthGuard]},
	{path:'psychometric-wls/:step',component:PsychometricWlsComponent, canActivate: [AuthGuard]},
	{path:'typing-simulation/:step',component:TypingSimulationComponent, canActivate: [AuthGuard]},
	{path:'adaptive-test-start/:step', component: AdaptiveLaunchpageComponent, canActivate: [AuthGuard] },
	{path:'adaptive-test/:step', component: AdaptiveComponent, canActivate: [AuthGuard] },
	{path:'adaptive-test-wls/:step', component: AdaptiveWlsComponent, canActivate: [AuthGuard] },
	{path:'adaptive-test/:step/:step1', component: AdaptiveComponent, canActivate: [AuthGuard] },
	{path:'adaptive-test-wls/:step/:step1', component: AdaptiveWlsComponent, canActivate: [AuthGuard] },
	{path: 'theory-test3/:step', component: Test3Component, canActivate: [AuthGuard] },
	{path: 'theory-test3-nols/:step', component: Test3NoStreamComponent, canActivate: [AuthGuard] },
	
	{ path: '**', redirectTo: '/home', pathMatch: 'full' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule { }

